// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingIndicator_wrapper__3M33C","loaderContainer":"LoadingIndicator_loaderContainer__A450d"};